<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { processSteps } from '../../constants/commission-process';
import { useProgressStore } from '../../stores/progressStore';

const props = defineProps({
  displayOnly: {
    type: Boolean,
    default: false,
  },
});

const progressStore = useProgressStore();
const { currentStep } = storeToRefs(progressStore);

const stepDisplay = (stepId: number) => stepId.toString().padStart(2, '0');
const canNavigate = (stepId: number) =>
  !props.displayOnly && stepId <= currentStep.value;
</script>

<template>
  <ol class="steps-list">
    <li v-for="step in processSteps" :key="step.id" class="step-item h3">
      <span class="step-num">{{ stepDisplay(step.id) }}</span>
      <span v-if="canNavigate(step.id)" class="step-label">
        <router-link
          :to="{ name: step.startOnPage }"
          @click="$emit('navigateAway')"
        >
          {{ step.label }}
        </router-link>
      </span>
      <span
        v-else
        class="step-label"
        :class="{
          'step-label--faded':
            !displayOnly && currentStep && step.id > currentStep,
        }"
      >
        {{ step.label }}
      </span>
    </li>
  </ol>
</template>

<style lang="less" scoped>
.steps-list {
  list-style: none;
  padding: 0;
  width: 100%;
  max-width: 600px;
}

.step-item {
  display: flex;
  align-items: baseline;
  gap: 16px;
  margin-bottom: 20px;

  font-size: 1.5em;
}

.step-num {
  min-width: 1em;

  font-size: 0.75em;
  color: @color-mid-green;
}

.step-label {
  color: @color-primary;

  a {
    color: @color-primary;
  }
}

.step-label--faded {
  color: @color-mid-green;
}
</style>
